/**
 * The installer module provides commonly used installation functions for Minecraft.
 * @packageDocumentation
 * @module @xmcl/installer
 */

export * from './fabric'
export * from './liteloader'
export * from './forge'
export * from './neoForged'
export * from './minecraft'
export * from './profile'
export * from './optifine'
export * from './java'
export * from './java-runtime'
export * from './diagnose'
export * from './quilt'
export { InstallOptions } from './utils'
export * from './downloadTask'
export * from './unzip'
export * from './labymod'
